export default __webpack_public_path__ + "static/media/Hockey Stadium, PKL4.70995df8.jpg";